<template>
  <div>
    <div class="text-center" style="width: 270px;">
      <span class="fs-14 mb-0 fw-semibold">
        {{ label }}
      </span>

      <span
        v-if="modalRequired"
        class="image-reference"
        @click="showFullImage"
        style="cursor: pointer;"
        title="Ver imagen completa"
      >
        (Referencia <font-awesome-icon :icon="['far', 'image']" fixed-width />)
      </span>
    </div>

    <!-- Full image modal -->
    <ImageFullModal
      v-if="fullImageUrl"
      :image-url="fullImageUrl"
      :disableControls="true"
      @close-modal="fullImageUrl = null"
    />
  </div>
</template>

<script>
import ImageFullModal from '../../shared/ImageFullModal'

const referenceImages = require.context('images/submital_required_photos', false, /\.webp$/)

export default {
  name: 'PhotoLabel',
  components: { ImageFullModal },
  props: {
    caption: { type: String, required: true, default: '' },
    label: { type: String, required: false, default: '' },
    modalRequired: { type: Boolean, required: false, default: false },
    source: { type: String, required: false, default: '' }
  },
  data () {
    return {
      missingPhoto: '/images/original/missing.png',
      fullImageUrl: null
    }
  },
  methods: {
    showFullImage () {
      if (!this.source) return this.missingPhoto
      try {
        const filename = `${this.caption}.webp`

        this.fullImageUrl = referenceImages(`./${filename}`)
      } catch (error) {
        this.fullImageUrl = this.missingPhoto
      }


    }
  }
}
</script>
